<template>
  <div class="page_content">
    <b-container fluid>
      <b-row class="page-content-section">
        <div class="left-container">
          <div class="employer-detail-title ace_sec_txt">
            <div class="employer-detail-title-left">
              <span class="ic_container">
                <span class="ic ico-employer"></span>
              </span>
              <h1
                class="head_txt module_type_name ace_sec_hd"
                role="heading"
                aria-level="1">
                {{ employer.displayName }}
              </h1>
              <span class="ic_container spotlight-star" v-if="spotlightEmployer" role="img" :aria-label="$t('spotlightEmployer')" :title="$t('spotlightEmployer')">
                <span class="ic icon-star-full" aria-hidden="true"></span>
              </span>
            </div>
            <button type="button" class="btn mapping-edit-btn" @click="editMapping">{{ $t('edit') }}</button>
          </div>
          <div class="employer-header-row">
            <div class="employer-meta">
              <div class="employer-meta-row">
                <div class="employer-meta-item">
                  <div class="icon_container">
                    <span class="icon-mail"></span>
                  </div>
                  <div class="ace_sec_txt">{{ email }}</div>
                </div>
                <div class="employer-meta-item">
                  <div class="icon_container">
                    <span class="icon-phone"></span>
                  </div>
                  <div class="ace_sec_txt">{{ phone }}</div>
                </div>
              </div>
              <div class="employer-meta-row">
                <div class="employer-meta-item">
                  <div class="icon_container">
                    <span class="icon-briefcase"></span>
                  </div>
                  <div class="ace_sec_txt">{{ jobPostedCount(employer) }} {{ $t('jobs') }}</div>
                </div>
                <div class="employer-meta-item">
                  <div class="icon_container">
                    <span class="icon-location"></span>
                  </div>
                  <div class="ace_sec_txt address-text">{{ address }}</div>
                </div>
              </div>
              <div class="employer-meta-row ace_sec_txt">
                <div class="employer-meta-item">
                  <div class="icon_container">
                    <span class="icon-checkmark status-approved" v-if="institutionStatus(employer) === 'Approved'"></span>
                    <span class="ic24-hour-glass" v-else></span>
                  </div>
                  <div class="ace_sec_txt">
                    {{ $t('status') }} : {{ institutionStatus(employer) }}
                  </div>
                </div>
                <div class="employer-meta-item">
                  <div class="icon_container">
                    <span class="icon-user"></span>
                  </div>
                  <div class="ace_sec_txt">
                    {{ $t('statusUpdatedBy') }} : {{ institutionStatusUpdatedBy(employer) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="employer-logo" v-if="employer.logo">
              <img :src="employer.logo" alt=""/>
            </div>
          </div>

          <div class="employer-meta-row description_row ace_sec_txt">
            <div class="employer-meta-item employer-description-item">
              <div class="icon_container">
                <span class="icon-paragraph-left"></span>
              </div>
              <div>
                <h1 class="head_txt module_type_name ace_sec_hd" role="heading" aria-level="1">
                  {{ $t('description') }} :
                </h1>
              </div>
            </div>
          </div>
          <div class="employer-meta-row description_row ace_sec_txt">
            <div class="employer-meta-item employer-description-item">
              <div class="job-description" v-if="employer.description" v-html="employer.description"></div>
              <div v-else class="no-description">{{ $t('noDescriptionForEmployer') }}</div>
            </div>
          </div>
          <div class="row url-row" v-if="employer.externalUrl">
            <div class="col-12 column-content">
              <span class="icon-link col-left" tabindex="0"></span>
              <span class="col-right long_url" tabindex="0">
                <b-link :href="employer.externalUrl" :title="employer.externalUrl" target="_blank">{{employer.externalUrl}}</b-link>
              </span>
            </div>
          </div>
        </div>
      </b-row>
    </b-container>
    <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="employerMappingModal" class="description_modal" size="md" id="institution-employer-details-mapping-popup" hide-footer>
        <div slot="modal-header" class="header-section">
          <div class="head_txt" style="margin-top: 1px;">{{ $t('employerMapping') }}</div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="closeEmployerMappingModal" data-dismiss="modal" :aria-label="$t('closeAria')">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row txt_row">
          <div class="col-6">
            {{ $t('employer') }} :
          </div>
          <div class="col-6 fld_val">
            <div v-html="employerMappingForEdit.employerTitle || employer.displayName"></div>
          </div>
        </div>
        <div class="row txt_row">
          <div class="col-6">
            {{ $t('status') }} :
          </div>
          <div class="col-6 fld_val">
            <select id="institution-employer-status" v-model="employerMappingForEditStatus" :aria-label="$t('status')" style="width: 80%;">
              <option v-for="statusValue in statusArray" :key="statusValue" :value="statusValue">{{ statusValue }}</option>
            </select>
          </div>
        </div>
        <div class="row txt_row">
          <div class="col-6">
            {{ $t('spotlightEmployer') }} :
          </div>
          <div class="col-6 fld_val">
            <select id="institution-employer-spotlight" v-model="employerMappingForEditSpotlight" :aria-label="$t('spotlightEmployer')" style="width: 80%;">
              <option :value="true">{{ $t('yes') }}</option>
              <option :value="false">{{ $t('no') }}</option>
            </select>
          </div>
        </div>
        <div class="row txt_row">
          <div class="col-6">
            {{ $t('updatedBy') }} :
          </div>
          <div class="col-6 fld_val">
            <div v-html="employerMappingForEdit.statusUpdatedByName"></div>
          </div>
        </div>
        <div class="row txt_row">
          <div class="col-6">
            {{ $t('updatedAt') }} :
          </div>
          <div class="col-6 fld_val">
            <div>{{ millisToDate(employerMappingForEdit.statusUpdatedTime) }}</div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12 btn_container" style="text-align: right;">
            <b-button @click="updateEmployerMappingStatus">
              {{ $tf('update') }}
            </b-button>
            <b-button @click="closeEmployerMappingModal">
              {{ $tf('cancel') }}
            </b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import '../../../assets/module/css/job/jobHomepage.min.css'
  import { DateTime } from 'luxon'
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'institutionEmployerDetails',
    props: {
      uuid: {
        type: String,
        default: ''
      },
      embedded: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        employer: {},
        employerMappingForEdit: {},
        employerMappingForEditStatus: 'Pending',
        employerMappingForEditSpotlight: false,
        statusArray: ['Approved', 'Pending', 'Disabled'],
        userObject: JSON.parse(localStorage.getItem('userobj'))
      }
    },
    mounted () {
      this.loadEmployer()
    },
    methods: {
    ...mapActions([
        'loadEmployerOrgInfo',
        'storeSelectedFactes',
        'updateEmployerMapping'
      ]),
      loadEmployer () {
        if (!this.uuid) {
          this.employer = {}
          return
        }
        this.loadEmployerOrgInfo(this.uuid).then(res => {
          this.employer = res || {}
        })
      },
      jobPostedCount (result) {
        if (!result || result.jobPosted === undefined || result.jobPosted === null || result.jobPosted === '') {
          return 0
        }
        return result.jobPosted
      },
      getEmployerMapping () {
        let mappings = (this.currentInstitution && this.currentInstitution.institutionEmployerMapping) ? this.currentInstitution.institutionEmployerMapping : []
        for (let i = 0; i < mappings.length; i++) {
          if (this.employer.uuid === mappings[i].employerId) {
            return mappings[i]
          }
        }
        return null
      },
      institutionStatus (result){
        let mapping = this.getEmployerMapping()
        return mapping && mapping.status ? mapping.status : ''
      },
      institutionStatusUpdatedBy (result){
        let mapping = this.getEmployerMapping()
        return mapping && mapping.statusUpdatedByName ? mapping.statusUpdatedByName : ''
      },
      millisToDate (millis) {
        if (!millis) {
          return 'N/A'
        }
        return DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
      },
      editMapping () {
        let mapping = this.getEmployerMapping()
        if (!mapping) {
          return
        }
        this.employerMappingForEdit = mapping
        this.employerMappingForEditStatus = mapping.status
        this.employerMappingForEditSpotlight = !!mapping.spotlightEmployer
        this.$refs.employerMappingModal.show()
      },
      closeEmployerMappingModal () {
        this.$refs.employerMappingModal.hide()
      },
      updateEmployerMappingStatus () {
        if (!this.currentInstitution || !this.employerMappingForEdit || !this.employerMappingForEdit.employerId) {
          return
        }
        this.updateEmployerMapping({
          institutionId: this.currentInstitution.uuid,
          employerId: this.employerMappingForEdit.employerId,
          status: this.employerMappingForEditStatus,
          spotlightEmployer: this.employerMappingForEditSpotlight
        }).then(() => {
          this.employerMappingForEdit.status = this.employerMappingForEditStatus
          this.employerMappingForEdit.spotlightEmployer = this.employerMappingForEditSpotlight
          if (this.userObject) {
            this.employerMappingForEdit.statusUpdatedByUuid = this.userObject.uuid
            this.employerMappingForEdit.statusUpdatedByName = (this.userObject.firstName || '') + ' ' + (this.userObject.lastName || '')
            this.employerMappingForEdit.statusUpdatedTime = Date.now()
          }
          this.$refs.employerMappingModal.hide()
          this.$emit('mapping-updated')
        })
      }
    },
    computed: {
      ...mapState({
        'currentInstitution' : state => state.institution.institution
      }),
      phone () {
        return this.employer.employerPhone || 'N/A'
      },
      email () {
        return this.employer.employerSupportEmail || 'N/A'
      },
      address () {
        return this.employer.address || 'N/A'
      },
      spotlightEmployer () {
        let mapping = this.getEmployerMapping()
        return mapping && mapping.spotlightEmployer
      }
    },
    watch: {
      uuid () {
        this.loadEmployer()
      }
    }
  }
</script>

<style scoped>
    .page-content-section .left-container {
      float: none;
      width: 100%;
      max-width: 100%;
      margin-top: 0;
    }


    .employer-detail-title-left {
      display: flex;
      align-items: center;
      flex: 1 1 auto;
      min-width: 0;
    }




    .employer-detail-title .spotlight-star {
      width: 24px;
      height: 26px;
      margin-left: 8px;
      margin-bottom: 2px;
    }

    .employer-detail-title .spotlight-star .icon-star-full {
      color: #ffd700;
      font-size: 22px !important;
      line-height: 1;
      margin: 0;
      display: block;
    }

    .employer-detail-title .mapping-edit-btn {
      margin-left: 12px;
      flex-shrink: 0;
      height: 28px;
      min-height: 28px;
      padding: 0 12px;
      line-height: 26px;
    }

    .employer-header-row {
      display: flex;
      align-items: center;
      width: 100%;
      min-width: 0;
      margin-bottom: 16px;
    }

    .employer-logo {
      flex: 0 0 auto;
      margin: 0 0 0 24px;
    }

    .employer-meta {
      flex: 1 1 auto;
      min-width: 0;
    }

    .employer-meta-row {
      display: grid;
      grid-template-columns: 0.85fr 1.15fr;
      column-gap: 0px;
      align-items: center;
      width: 100%;
      margin-bottom: 25px;
      margin-left:30px;
    }

    .employer-meta-row:last-child {
      margin-bottom: 0;
    }

    .address_row {
      grid-template-columns: 1fr;
    }


    .address-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }






    .employer-logo img {
      max-height: 80px;
      max-width: 240px;
      width: auto;
      height: auto;
    }

    .description_row {
      display: flex;
      grid-template-columns: none;
      min-height: 24px;
      margin-top: 16px;
      margin-bottom: 0;
    }

    .employer-description-item {
      width: 100%;
      white-space: normal;
    }

    .job-description {
      width: 100%;
      display: block;
      white-space: pre-wrap;
      word-wrap: break-word;
      margin-top: 0;
      margin-bottom: 24px;
      padding-left: 4em;
      line-height: 1.5;
    }

    .job-description >>> * {
      line-height: 1.5;
    }

    .no-description {
      margin-bottom: 24px;
      padding-left: 4em;
      line-height: 1.5;
    }
</style>



// WEBPACK FOOTER //
// src/app/job/components/InstitutionEmployerDetails.vue